import { useState } from 'react'
import { F0Box, F0Button, F0Dialog, F0Heading, F0OneIcon, F0Text } from '@factorialco/f0-react'
import { useVoiceSession } from 'modules/ai_voice/providers/voiceSession'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { demoTourTasks } from 'modules/get_started/lib/demo-tours/taskCatalog'

const DemoAiTours = () => {
  const [isOpen, setIsOpen] = useState(true)
  const { setParams, startSession } = useVoiceSession()
  const { has_show_ai_demo_tours: showAiDemoTours } = useFeatures(['show_ai_demo_tours'])

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleStartTour = (taskKey: string) => {
    setParams({ agent: 'onboarding', task: taskKey })
    startSession()
    setIsOpen(false)
  }

  if (!showAiDemoTours) return null

  return (
    <F0Dialog isOpen={isOpen} onClose={handleClose} width="sm" disableContentPadding>
      <F0Box position="relative" paddingX="xl" paddingY="xl">
        <F0Box display="flex" flexDirection="column" alignItems="center" gap="xl">
          <F0Box display="flex" flexDirection="row" alignItems="center" gap="md">
            <F0OneIcon size="md" />
            <F0Text content="Take a tour with One" variant="label" color="upgrade" />
          </F0Box>
          <F0Heading as="h2" variant="heading-large" content="Welcome to Factorial" />
          <F0Text
            content="Discover how Factorial can transform your HR processes. Explore our key features and see how we solve your biggest challenges."
            variant="body"
            align="center"
          />
          <F0Box display="flex" flexDirection="column" gap="md" paddingTop='sm'>
            {demoTourTasks.map((task) => (
              <F0Button
                key={task.taskKey}
                variant="outline"
                label={task.title}
                onClick={() => handleStartTour(task.taskKey)}
              />
            ))}
          </F0Box>
        </F0Box>
      </F0Box>
    </F0Dialog>
  )
}

export default DemoAiTours
